import { Link } from "react-router-dom";
import { Form, Input, Row, Table } from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useEffect, useState } from "react";
import { useCommonDataFindAllQuery, useLabratorDetailCreateMutation, useLabratorDetailFindAllQuery, useLabratorDetailUpdateMutation } from "store";
const Analysis = (props: any) => {

  const [analysisDetailTypeData, setAnalysisDetailTypeData] = useState<any>();
  const [analysisDataList, setAnalysisDataList] = useState<any>();
  const [labratorDetailCreate, entityCreateResult] = useLabratorDetailCreateMutation();
  const [labratorDetailUpdate, entityUpdateResult] = useLabratorDetailUpdateMutation();

  const {
    data: analysisData,
    error: analysisDataError,
    isFetching: isAnalysisDataFetching,
    } = useLabratorDetailFindAllQuery(`/${props?.table_id}`);

  const {
    data: commonData,
    error: commonDataError,
    isFetching: isCommonDataFetching,
  } = useCommonDataFindAllQuery('?group_name=cmn_lab_unit_type');

  useEffect(() => {
    console.log(props);
    
    setAnalysisDetailTypeData(commonData?.data);
    setAnalysisDataList(commonData?.data);
    console.log(analysisDataList);
    
  }, [commonData, analysisDetailTypeData])

  const initialValues = (analysisData?.data || []).reduce((acc, item) => {
    if (!item) return acc; 
  
    return {
      ...acc,
      ...(item.cmn_lab_unit_type ? { [`nak-${item.cmn_lab_unit_type}`]: item.nak ?? '' } : {}),
      ...(item.cmn_lab_unit_type ? { [`nh4-${item.cmn_lab_unit_type}`]: item.nh4 ?? '' } : {}),
      ...(item.cmn_lab_unit_type ? { [`ca-${item.cmn_lab_unit_type}`]: item.ca ?? '' } : {}),
      ...(item.cmn_lab_unit_type ? { [`mg-${item.cmn_lab_unit_type}`]: item.mg ?? '' } : {}),
      ...(item.cmn_lab_unit_type ? { [`fe2-${item.cmn_lab_unit_type}`]: item.fe2 ?? '' } : {}),
      ...(item.cmn_lab_unit_type ? { [`fe3-${item.cmn_lab_unit_type}`]: item.fe3 ?? '' } : {}),
      ...(item.cmn_lab_unit_type ? { [`ci-${item.cmn_lab_unit_type}`]: item.ci ?? '' } : {}),
      ...(item.cmn_lab_unit_type ? { [`so4-${item.cmn_lab_unit_type}`]: item.so4 ?? '' } : {}),
      ...(item.cmn_lab_unit_type ? { [`no-${item.cmn_lab_unit_type}`]: item.no ?? '' } : {}),
      ...(item.cmn_lab_unit_type ? { [`no2-${item.cmn_lab_unit_type}`]: item.no2 ?? '' } : {}),
      ...(item.cmn_lab_unit_type ? { [`hco3-${item.cmn_lab_unit_type}`]: item.hco3 ?? '' } : {}),
      ...(item.cmn_lab_unit_type ? { [`co3-${item.cmn_lab_unit_type}`]: item.co3 ?? '' } : {}),
      ...(item.cmn_lab_unit_type ? { [`o2-${item.cmn_lab_unit_type}`]: item.o2 ?? '' } : {}),
    };
  }, {});

  const validation: any = useFormik({
    enableReinitialize: true,

    initialValues,
    validationSchema: Yup.object({
      // average_depth: Yup.number().required("Тоо оруулна уу !"),
    }),
    onSubmit: (values: any) => {
      const tempArrayUpdate = { data: [] as Array<Record<string, any>> };
      console.log(values);
      if(analysisDataList === undefined){
        analysisDetailTypeData?.forEach((item) => {
          const endingValues = Object.keys(values)
            .filter((key) => key.endsWith(`-${item?.id}`))
            .reduce((obj, key) => {
              obj[key] = values[key];
              return obj;
            }, {});
        });
      }else{
        analysisDetailTypeData?.forEach((item) => {
          const updateDetail = Object.keys(values)
            .filter((key) => key.endsWith(`-${item?.id}`))
            .reduce((obj, key) => {
              const newKey = key.replace(`-${item?.id}`, ''); 
              obj[newKey] = values[key];
              return obj;
            }, {});
        
          updateDetail['lab_id'] = props?.table_id;
          updateDetail['cmn_lab_unit_type'] = item?.id;
          tempArrayUpdate.data.push(updateDetail);
        });
        labratorDetailUpdate(tempArrayUpdate)
        console.log(tempArrayUpdate);
        
      }
      validation.resetForm();
    },
  });
  return (
    <>
      <Row>
        <Form
          className="p-0 text-center"
          onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit();
            return false;
          }}
        >
          <div className="table-responsive">
            <Table className="table mb-0 table-bordered border-primary">
              <thead>
                <tr>
                  <th className="text-center" rowSpan={2}>  <div className="d-flex justify-content-center align-items-center" style={{ height: '60px', width: '120px' }}> Хэмжих нэгж</div>  </th>
                  <th colSpan={13} className="text-center"> Химийн найрлага </th>
                </tr>
                <tr>
                  <th className="text-center"> На + К </th>
                  <th className="text-center"> NH<sub>4</sub> </th>
                  <th className="text-center"> CA </th>
                  <th className="text-center"> Mg </th>
                  <th className="text-center"> Fe<sub>2</sub>  </th>
                  <th className="text-center"> Fe<sub>3</sub>  </th>
                  <th className="text-center"> CI </th>
                  <th className="text-center"> SO<sub>4</sub> </th>
                  <th className="text-center"> NO </th>
                  <th className="text-center"> NO<sub>2</sub> </th>
                  <th className="text-center"> HCO<sub>3</sub> </th>
                  <th className="text-center"> CO<sub>3</sub> </th>
                  <th className="text-center"> O<sub>2</sub> </th>
                </tr>
                {analysisDetailTypeData?.map((item, index) => (
                  <tr key={index}>
                    <th className="text-center"> {item?.name} </th>
                    {['nak', 'nh4', 'ca', 'mg', 'fe2', 'fe3', 'ci', 'so4', 'no', 'no2', 'hco3', 'co3', 'o2'].map((field, i) => (
                      <td style={{ width: '100px' }} key={i}>
                        <Input
                          name={`${field}-${item?.id}`}
                          type="text"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values[`${field}-${item?.id}`] || ""}
                          invalid={
                            validation.touched[`${field}-${item?.id}`] &&
                              validation.errors[`${field}-${item?.id}`]
                              ? true
                              : false
                          }
                        />
                      </td>
                    ))}
                  </tr>
                ))}
              </thead>
            </Table>

          </div>
          <button type="submit" className="btn btn-primary mt-3"> Хадгалах </button>
        </Form>
      </Row>

    </>
  );
};

export default Analysis;
